import React, { useEffect, useState } from "react";
import { Modal, Row, Col, Form } from "antd";
import { colors } from "../../../Utils/constants";
import ButtonComp from "../../ButtonComp/ButtonComp";
import {
  CheckCircleFilled,
  CloseCircleFilled,
} from "../../../Utils/imports";
import "./BasicModal.css";
import Loader from "../../Helpers/Loader";
import { useDispatch } from "react-redux";

const BasicModal = (props) => {
  let {
    id,
    title,
    children,
    btn1Text,
    btn2Text,
    open,
    handleOK,
    handleCancel,
    okDisabled,
    apiFunc,
    reRenderCond
  } = props;

  const onFinish = (values) => {
    console.log(values)
  }

  return (
    <Modal
      width={id === "3" || id === "4" ? "40%" : "30%"}
      title={<h2 className="pageHead">{title}</h2>}
      open={open}
      maskClosable={false}
      footer={null}
      onCancel={handleCancel}
    >
      <Loader loading={props.loading}>
        <div>
          <Row className="dflex alignCenter justifyCenter pb30">{children}</Row>
          <Row className="dflex alignCenter justifyCenter gap10" >
            <ButtonComp
              style={{ width: id === "3" || id === "4" ? "30%" : "40%" }}
              theme={"blue"}
              text={btn1Text}
              icon={<CheckCircleFilled />}
              onClick={handleOK}
              isDisabled={okDisabled}
            />
            <ButtonComp
              style={{ width: id === "3" || id === "4" ? "30%" : "40%" }}
              theme={"red"}
              text={btn2Text}
              icon={<CloseCircleFilled />}
              onClick={handleCancel}
            />
          </Row>
        </div>
      </Loader>
    </Modal>
  );
};

export default BasicModal;
